import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bf89ee90"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Important Documents Needed")
], -1));
const _hoisted_3 = { class: "columns mt-4" };
const _hoisted_4 = { style: { "display": "flex", "flex-direction": "row", "width": "100%" } };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "flex-grow": "1" } }, null, -1));
import { notifyError } from "@/core/utils";
import { onMounted, ref } from "vue";
import { isValidImage } from "../model";
import DocumentUploadField from "./DocumentUploadField.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerUserOnboardingFormDocumentsPage',
    props: {
        modelValue: {}
    },
    emits: ['update:modelValue', 'back', 'proceed'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const formState = ref();
        onMounted(() => {
            formState.value = Object.assign({}, props.modelValue);
        });
        const onChanged = () => {
            emit("update:modelValue", formState.value);
        };
        const onSubmitClicked = () => {
            if (!isValidImage(formState.value.request.profile.workBadge)) {
                notifyError("Please upload your work badge in .PNG/.JPG format");
                return;
            }
            if (!isValidImage(formState.value.request.profile.stateId)) {
                notifyError("Please upload your state ID in .PNG/.JPG format");
                return;
            }
            emit('proceed');
        };
        return (_ctx, _cache) => {
            const _component_SaveButton = _resolveComponent("SaveButton");
            return (formState.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(DocumentUploadField, {
                            class: "column",
                            modelValue: formState.value.request.profile.workBadge,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formState.value.request.profile.workBadge) = $event)),
                            onChange: _cache[1] || (_cache[1] = ($event) => (onChanged())),
                            label: "Work Badge *",
                            description: "Please upload a scan or photograph of your work badge, as a .PNG/.JPG image file.",
                            allowedTypes: ['IMAGE']
                        }, null, 8, ["modelValue"]),
                        _createVNode(DocumentUploadField, {
                            class: "column",
                            modelValue: formState.value.request.profile.stateId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formState.value.request.profile.stateId) = $event)),
                            onChange: _cache[3] || (_cache[3] = ($event) => (onChanged())),
                            label: "State ID *",
                            description: "Please upload a scan or photograph of your state ID, as a .PNG/.JPG image file.",
                            allowedTypes: ['IMAGE']
                        }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createVNode(_component_SaveButton, {
                            class: "mr-2",
                            large: "",
                            label: "Back",
                            icon: "fa-chevron-left",
                            onClick: _cache[4] || (_cache[4] = ($event) => (emit('back')))
                        }),
                        _createVNode(_component_SaveButton, {
                            large: "",
                            label: "Next",
                            icon: "fa-chevron-right",
                            iconRight: "",
                            onClick: _cache[5] || (_cache[5] = ($event) => (onSubmitClicked()))
                        })
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
